import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Col, Row, Container, Card, Form, Button } from "react-bootstrap";
import { useInView } from "react-intersection-observer";
import { useAnimation, motion } from "framer-motion";

import Title from "../../components/TitleIzquierda";
import { ROUTES } from "../../constants/routes";

import "../../styles/components/Contacto.scss";

const boxVariant = {
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  hidden: { opacity: 0, y: 200 },
};

export default function Contacto() {
  const control = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      control.start("visible");
    }
  }, [control, inView]);

  return (
    <motion.div
      className="box Contacto"
      ref={ref}
      variants={boxVariant}
      initial="hidden"
      animate={control}
    >
      <Title titulo="Contáctanos" scroll={inView}/>
      <Container>
        <Row className="mt-5 mb-5">
          <Card
            style={{
              maxWidth: "100%!important",
              textAlign: "justify",
            }}
            className="cardTransparent"
          >
            <Row className="g-0 align-items-center">
              <Col className="backgroundGray">
                <Card.Header>
                  Dejanos un mensaje breve explicando tu idea o necesidad y nos
                  pondremos en contacto.
                </Card.Header>
                <Card.Body>
                  <Form>
                    <Form.Group className="mb-3" controlId="formBasicNombre">
                      <Form.Label>
                        Nombre Completo
                      </Form.Label>
                      <Form.Control type="text" placeholder="Nombre Completo" />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Correo</Form.Label>
                      <Form.Control type="email" placeholder="Correo" />
                    </Form.Group>

                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Label>Mensaje</Form.Label>
                      <Form.Control as="textarea" rows={3} />
                    </Form.Group>

                    <NavLink to={ROUTES.CONTACTO}>
                      <Button className="botonColor">Enviar</Button>
                    </NavLink>
                  </Form>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </Row>
      </Container>
    </motion.div>
  );
}
